export const baseApiUrl = function() {
    let baseUrl = '';

    if (process.env.REACT_APP_BUILD_TARGET == 'staging') {
        baseUrl = 'https://stage-api.spindlplatform.com/';
    } else if (process.env.NODE_ENV == 'production') {
        baseUrl = 'https://api.spindlplatform.com/';
    } else if (process.env.NODE_ENV == 'development') {
        baseUrl = 'http://localhost:8080/';
    } else {
        baseUrl = 'http://localhost:8080/';
    }
    return baseUrl;
};



// WEBPACK FOOTER //
// ./src/config.js